//------------ REACT IMPORT --------------//
import React, { useEffect } from "react";
//--------- FONTAWESOME IMPORTS ----------//
import { faArrowLeft, faChevronRight, faPlus, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//--------- IMAGES IMPORTS ----------//
import { Menu, NotificationBell, Search } from "../../assets/images";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Image } from "react-bootstrap";
import AuthController from "../../apis/Controllers/AuthController/AuthController";
import { setUserData } from "../../redux/actions/users";
import store from "../../redux/store";
import { useNavigate } from "react-router-dom";


const WithoutImageHeader = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
        getUserData();
    }, []);


    const getUserData = async () => {
        window.scrollTo(0, 0);
        let item = localStorage.getItem('SET_USER_DATA');
        item = JSON.parse(item);
        let user = item;
        if (user) {
            if (user && user.access && user.access.token) {
                await store.dispatch(setUserData(user));
            }
        }
        else {
            logout();
        }
    };


    const logout = async () => {
        store.dispatch(setUserData({}));
        localStorage.clear();
        navigate("/login");
    };

    const openNav = () => {
        document.getElementById("mySidenav").style.width = "450px";
    };

    const closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    };

    return (
        <>
            <style>
                {`
          body {
            font-family: "Lato", sans-serif;
          }

          .sidenav {
            height: 100%;
            width: 0;
            position: fixed;
            z-index: 1;
            top: 0;
            left: 0;
            background-color: #ffffff;
            overflow-x: hidden;
            transition: 0.5s;
            padding-top: 60px;
          }

          .sidenav a {
            padding: 8px 8px 8px 32px;
            text-decoration: none;
            font-size: 25px;
            color: #818181;
            display: block;
            transition: 0.3s;
          }

          .sidenav a:hover {
            color: #f1f1f1;
          }

          .sidenav .closebtn {
            position: absolute;
            top: 0;
            right: 25px;
            font-size: 36px;
            margin-left: 50px;
          }

          @media screen and (max-height: 450px) {
            .sidenav {padding-top: 15px;}
            .sidenav a {font-size: 18px;}
          }
        `}
            </style>
            <div id="mySidenav" className="sidenav">
                <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>&times;</a>
                <a href="/dashboard-superadmin">Dashboard</a>
                <a href="/hospital-listing">Manage Hospitals</a>
                <a href="/dashboard-superadmin">Manage Staff</a>
                <a href="/dashboard-superadmin">Manage Patient</a>
                <a href="/dashboard-superadmin">Manage Tasks</a>
                <a href="/role-list">Manage Roles</a>
                <a href="" onClick={() => AuthController.logout()}>Logout</a>
            </div>
            <div className="without_image_header">
                <div className="header_area">
                    <div className="details">
                        {props.lefticon === 'menu' ?
                            <div className="menu_icon">
                                <div className="img_menu">
                                    <Image src={Menu} alt="..." onClick={openNav} />
                                </div>
                            </div>
                            :
                            <FontAwesomeIcon icon={faArrowLeft} className="arrow" onClick={() => props && props.handleBack ? props.handleBack() : ''} />}
                        <h3>{props.header}</h3>
                        {props.icon === "edit" ?
                            <div className="icon_user" onClick={() => props && props.handleNavigate ? props.handleNavigate() : ''}>
                                <FontAwesomeIcon icon={faUserPen} />
                            </div>
                            :
                            props.icon === "notification" ?
                                <div className="search_area">
                                    <div className="img_search">
                                        <Image src={NotificationBell} alt="..." />
                                    </div>
                                </div>
                                :
                                props.icon === "add" ?
                                    <div className="add_area">
                                        <a href="javascript:;"><FontAwesomeIcon icon={faPlus} className="add_icon" />Add</a>
                                    </div>
                                    : props.icon === "search_bell" ?
                                        <div className="icon_area">
                                            <div className="img_one">
                                                <Image src={Search} alt="..." />
                                            </div>
                                            <div className="img_two">
                                                <Image src={NotificationBell} alt="..." />
                                            </div>
                                        </div> : null}
                    </div>
                    <div className="breadcrum_area">

                        {props.breadcrumData ? props.breadcrumData.map((item, i) =>
                            <div>
                                <a href="#javscript:;" >{item}</a><FontAwesomeIcon icon={faChevronRight} className="icon" />
                            </div>
                        ) : null}

                        <span>{props.breadcrumItem}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WithoutImageHeader;